module.exports = __webpack_public_path__ + "img/account-detail.a6652b60.svg";